'use client'

import type React from 'react'

import { cx } from '@news/styled-system/css'
import { useI18n } from '@/shared/providers'

import { useActiveLaw } from './provider/use-active-law'

type SelectCookiesButtonProps = {
    className?: string
    as?: React.ElementType
}

export function SelectCookiesButton({ className, as: Component = 'span' }: SelectCookiesButtonProps) {
    const { i18n } = useI18n()
    const activeLaw = useActiveLaw()

    if (!activeLaw) {
        return null
    }

    return (
        <Component className={cx('cky-banner-element', className)}>
            {activeLaw === 'ccpa' ? i18n.LINK_LEGAL_COOKIES__SHORT_CCPA : i18n.LINK_LEGAL_COOKIES__SELECT}
        </Component>
    )
}
